import { Http } from '@/lib/http';
import { assertRangeRows } from '@/modules/shared/utils/range-row-limits.mjs';

export class RiskFactorService extends Http {
  constructor() {
    super();
    this.endpoint = 'settings/general-settings/risk-factors/';
    this.subEndpoint = 'settings/general-settings/sub-risk-factors/';
  }

  getRiskFactors() {
    return this.httpClient().get(`${this.endpoint}`);
  }

  getPaginatedRiskFactors(params) {
    return this.httpClient().get(`${this.endpoint}paginated`, { params });
  }

  getRiskFactorById(id) {
    return this.httpClient().get(`${this.endpoint}${id}`);
  }

  getRiskFactorByModuleName(moduleName) {
    return this.httpClient().get(`${this.endpoint}module/${moduleName}`);
  }

  getRiskFactorByName(name) {
    return this.httpClient().get(`${this.endpoint}name/${name}`);
  }

  updateRiskFactor(payload) {
    return this.httpClient().patch(`${this.endpoint}${payload.id}`, payload);
  }

  createSubRiskFactor(payload) {
    return this.httpClient().post(`${this.subEndpoint}`, payload);
  }

  getSubRiskFactors() {
    return this.httpClient().get(`${this.subEndpoint}`);
  }

  updateSubRiskFactor(payload) {
    return this.httpClient().patch(`${this.subEndpoint}${payload.id}`, payload);
  }

  deleteSubRiskFactor(id) {
    return this.httpClient().delete(`${this.subEndpoint}${id}`);
  }

  updateRiskFactorList() {
    return this.httpClient().get(`${this.endpoint}update/factors`);
  }

  batchUpdateSubRiskFactorRanges(payload) {
    assertRangeRows(payload?.payload);
    console.log({payload})
    return this.httpClient().put(`${this.subEndpoint}`, payload);
  }
}
